import { Combobox } from '@/components/common/Combobox'
import type { FieldEntry } from './types'

export function FieldPicker({
  fields, value, onChange,
}: {
  fields: FieldEntry[]
  value: string
  onChange: (path: string) => void
}) {
  return (
    <Combobox<string>
      value={value || null}
      onChange={v => onChange(v ?? '')}
      options={fields.map(f => ({ value: f.path, label: f.label }))}
      emptyOptionLabel="— pole —"
      placeholder="— pole —"
      className="w-44 text-sm"
    />
  )
}
